import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-emerald-50 to-teal-50 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-2">
            <div className="text-3xl font-light text-emerald-600 tracking-wider mb-6">
              AURA BOTANICA
            </div>
            <p className="text-sm text-gray-600 leading-relaxed mb-6">
              自然の恵みと先進技術が融合した、<br />
              次世代ボタニカルヘアケアブランド。<br />
              髪本来の美しさを引き出します。
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              >
                <i className="ri-instagram-line text-xl text-emerald-600"></i>
              </a>
              <a 
                href="https://x.com/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-sm hover:shadow-md transition-shadow cursor-pointer"
              >
                <i className="ri-twitter-x-line text-xl text-emerald-600"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 mb-4">MENU</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer">
                  TOP
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer">
                  ABOUT
                </Link>
              </li>
              <li>
                <Link to="/products" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer">
                  PRODUCTS
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer">
                  NEWS
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-gray-800 mb-4">SUPPORT</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer">
                  CONTACT US
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors cursor-pointer">
                  PRIVACY POLICY
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-xs text-gray-500">
              ※表示価格は希望小売価格です。
            </p>
            <p className="text-xs text-gray-500">
              ©2024 AURA BOTANICA, All Rights Reserved. | <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="hover:text-emerald-600 transition-colors cursor-pointer">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}